module.exports = __webpack_public_path__ + "img/logo-map.f1a79d81.png";